import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../context/LocalizationContext";
import { useAppContext } from "../../context/AppContext";
import { useUserData } from "../../hooks/useUserData";
import { useAuth } from "../../context/AuthContext";
import { endSession } from "../../utils/api";
import "./EndSession.css";
import exitIcon from "../../assets/icons/exit.svg";
import welcomeVideo from "../../assets/videos/welcome.mp4";
import HomeIcon from "../../assets/icons/home.svg";

const EndSession = () => {
  const navigate = useNavigate();
  const { t, isRTL } = useLocalization();
  const { savedAnswers, clearAnswers, resetState } = useAppContext();
  const { userData } = useUserData();
  const { logout } = useAuth();
  const [isEnding, setIsEnding] = useState(false);
  const logoutInitiated = useRef(false);

  const handleEndSession = (e) => {
    // Prevent default and stop propagation
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Prevent multiple clicks using ref (more reliable than state)
    if (logoutInitiated.current || isEnding) {
      return;
    }

    // Mark as initiated immediately
    logoutInitiated.current = true;
    setIsEnding(true);

    try {
      const sessionId = userData?.sessionId || 123;
      // Try to end session via API (fire and forget - don't wait)

      endSession("192.168.1.100", sessionId).catch(err => {
        console.error('Error ending session via API:', err);
      });


      // Clear saved answers and reset state
      Object.keys(savedAnswers).forEach((assessmentId) => {
        clearAnswers(assessmentId);
      });
      resetState();

      // Logout immediately - this will redirect
      logout();
    } catch (error) {
      console.error('Error in handleEndSession:', error);
      // Clear state and logout even on error
      Object.keys(savedAnswers).forEach((assessmentId) => {
        clearAnswers(assessmentId);
      });
      resetState();
      logout();
    }
  };

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <h1 className="welcome-title">{t("endSession.title")}</h1>
        <button
          className="welcome-start-button"
          onClick={handleEndSession}
          disabled={isEnding}
        >
          {t("endSession.endButton")}
          <img
            src={exitIcon}
            alt="arrow"
            className="arrow-icon"
            style={{
              transform: isRTL ? "rotate(180deg)" : "none",
              marginLeft: isRTL ? 0 : "1vw",
              marginRight: isRTL ? "1vw" : 0,
              transition: "transform 0.3s ease",
            }}
          />
        </button>
      </div>
      <video className="welcome-video" autoPlay loop muted playsInline>
        <source src={welcomeVideo} type="video/mp4" />
      </video>

      <div className="assessment-footer">
        <button
          className="footer-btn home-btn"
          onClick={() => navigate("/dashboard")}
        >
          <img src={HomeIcon} alt="Home" />
        </button>
      </div>
    </div>
  );
};

export default EndSession;
